import React from 'react'
import { FormattedMessage } from 'react-intl'
import rolesList from 'const/rolesList'
import useChannel from 'hooks/useChannel'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import {
  LeftSidebarView,
} from 'components/Sidebar'
import {
  ListItem
} from 'components/List'
import UsersByRole from '../UsersByRole'

export function Roles ({
  leftSidebar
}) {
  useChannel('userRoles')

  return (
    <LeftSidebarView
      title={<FormattedMessage id='USER_ROLES' />}
    >
      {rolesList.map(role =>
        <ListItem
          key={role.id}
          onClick={() => {
            leftSidebar.push(() => <UsersByRole roleId={role.id} />)
          }}
        >
          <FormattedMessage id={role.formattedMessageId} />
        </ListItem>
      )}
    </LeftSidebarView>
  )
}

export default withLeftSidebar(Roles)
